import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class PaymentService {
  getProducts() {
    return axios.get(API_URL + "payment/products", {
      headers: authHeader(),
    });
  }

  postProductGetCheckoutForm(body: any) {
    return axios.post(API_URL + "payment/checkoutform", body, {
      headers: authHeader(),
    });
  }

  savePayment(token: any) {
    return axios.post(API_URL + "payment/issuepayment", token, {
      headers: authHeader(),
    });
  }
}

export default new PaymentService();
